export const ADD_FORM = "add_customer_form";
export const SELECT_CUSTOMER_FORM = "select_customer_form";
export const INVOICE_DETAIL_FORM = "invoice_detail_form";

export const INCENTIVES_DETAIL_FORM = "fetch_incentives_detail_form";

export const CUSTOMERS_PAGE_COUNT = 30;
